import { PartnerClientMonthReport } from 'types/partnerClientManagerTypes';
import { M8ClientIncomeHistory } from '../types';
import { normalizeM8DateString } from './normalizeM8DateString';

export function normalizeM8ClientIncomeHistoryRecord(
  m8ClientIncomeHistoryRecord: M8ClientIncomeHistory
) {
  return {
    toPartnerClientMonthReport(): PartnerClientMonthReport {
      const startDateISO = normalizeM8DateString(
        m8ClientIncomeHistoryRecord.beginPeriod
      )
        .toDate()
        .toISOString();

      const endDateISO = normalizeM8DateString(
        m8ClientIncomeHistoryRecord.endPeriod
      )
        .toDate()
        .toISOString();

      return {
        period: {
          startDateISO,
          endDateISO,
        },
        licensesCount: m8ClientIncomeHistoryRecord.licensesCount,
        tariffAmount: m8ClientIncomeHistoryRecord.tariffForClient,
        debitIsPaid: m8ClientIncomeHistoryRecord.status === 'PAID',
        isFullMonth: m8ClientIncomeHistoryRecord.fullPeriod,
        monthIncome: m8ClientIncomeHistoryRecord.totalForMonth,
        periodIncome: m8ClientIncomeHistoryRecord.totalForPeriod,
        periodIncomePercent: m8ClientIncomeHistoryRecord.percentForPeriod,
        partnerIncome: m8ClientIncomeHistoryRecord.yourAmount,
        partnerIncomePercent: m8ClientIncomeHistoryRecord.yourPercent,
      };
    },
  };
}
